import { SensorPortCommunicationMode } from "../../../portConfigs.js";
import { SensorClusterConfig } from "../types.js";

function makeSolenoidVerificationCluster(
    friendlyName: string,
    elementKey: "gen4SolenoidVerification" | "saplingVerification",
): SensorClusterConfig<Record<string, never>> {
    return {
        communicationMode: SensorPortCommunicationMode.DIGITAL,
        requiredSubChannels: [],
        optionalSubChannels: [],
        isPermanentlyAttached: true,
        parameterConfigs: {},
        manufacturerName: "Verdi",
        modelName: "Solenoid Verification",
        friendlyName,
        friendlyShortName: "Solenoid",
        generateSensorElements: () => [
            {
                sensorElementConfigKey: elementKey,
                parameters: {},
                legalConvertedRange: [null, null],
                subChannel: 0,
            },
        ],
    };
}

const lastErrorCodeBase: Omit<SensorClusterConfig<Record<string, never>>, "generateSensorElements"> = {
    communicationMode: SensorPortCommunicationMode.DIGITAL,
    requiredSubChannels: [],
    optionalSubChannels: [],
    isPermanentlyAttached: true,
    parameterConfigs: {},
    manufacturerName: "Verdi",
    modelName: "Last Error Code",
    friendlyName: "Last Error Code",
    friendlyShortName: "Error",
};

export const solenoidClusterConfigs: Record<string, SensorClusterConfig<Record<string, never>>> = {
    Gen4_ValveAndSolenoid: {
        communicationMode: SensorPortCommunicationMode.DIGITAL,
        requiredSubChannels: [],
        optionalSubChannels: [],
        isPermanentlyAttached: true,
        parameterConfigs: {},
        manufacturerName: "Verdi",
        modelName: "Valve State & Solenoid Verification",
        friendlyName: "Valve & Solenoid",
        friendlyShortName: "Valve",
        generateSensorElements: () => [
            {
                sensorElementConfigKey: "valveState",
                parameters: {},
                legalConvertedRange: [null, null],
                subChannel: 0,
            },
            {
                sensorElementConfigKey: "gen4SolenoidVerification",
                parameters: {},
                legalConvertedRange: [null, null],
                subChannel: 1,
            },
        ],
    },

    SeedSap_SaplingVerification: makeSolenoidVerificationCluster(
        "Sapling Solenoid Verification",
        "saplingVerification",
    ),

    Gen4_LastErrorCode: {
        ...lastErrorCodeBase,
        generateSensorElements: () => [
            {
                sensorElementConfigKey: "digitalCode",
                parameters: {},
                legalConvertedRange: [null, null],
                subChannel: 0,
            },
        ],
    },
};
